<div class="m-15" style="padding-bottom: 110px">
  <div class="pages-header" style="display: block">
    <h1 class="mobile-move-title">Templates</h1>

    <!-- Desktop workspace tabs -->
    <div class="ch-tabs workspace-tabs templates-tabs">
      <div
        class="internal"
        [ngClass]="{ active: jobsTab }"
        (click)="switchTabs('jobsTab')"
      >
        Jobs Templates
      </div>
      <div
        class="internal"
        [ngClass]="{ active: clientTaskTab }"
        (click)="switchTabs('clientTaskTab')"
      >
        Client Tasks Templates
      </div>
    </div>
  </div>

  <!-- Job templates -->
  @if (clientTaskTab) {
    <div
      class="tracked-item-dashboard-wapper"
      [ngClass]="{ 'd-flex': templates.length == 0 }"
    >
      @if (templates.length == 0) {
        <div class="d-flex align-items-center">
          <div
            style="padding: 0 20px; width: 650px; max-width: 100%"
            class="text-center"
          >
            <h4>You have no client task templates</h4>
            <p>
              To create a client task template, open a client workspace, choose
              "New Client Tasks" to draft a set of Client Tasks and there,
              choose the "Save as Template" button.
            </p>
          </div>
        </div>
      }
      @if (templates.length > 0) {
        <div class="row">
          <div class="col-sm-4 col-lg-3 border-right">
            <div class="clients-list scrollable">
              @for (template of templates; track template) {
                <div (click)="selectTemplate(template)">
                  <a
                    class="clients-list-item"
                    [ngClass]="{ active: active_template.id == template.id }"
                  >
                    <div class="clients-list-name">{{ template.name }}</div>
                  </a>
                </div>
              }
            </div>
          </div>
          <div class="col-sm-8 col-lg-9">
            <div class="tracked-item-template-bg">
              <div class="row modal-row d-flex">
                <div
                  class="col-sm-8 col-md-7 left-column"
                  #scrollMe
                  [scrollTop]="scrollMe.scrollHeight"
                >
                  <div
                    class="tracked-items-preview tracked-items-template scrollbars"
                  >
                    <div class="form-group">
                      <label for="conversationName">Template name</label>
                      <div class="row">
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Template name"
                            [(ngModel)]="active_template.name"
                            autofocus
                          />
                        </div>
                        <div class="col-md-4">
                          <button
                            (click)="updateTrackedItemsTemplate()"
                            class="btn btn-primary btn-block"
                            style="padding: 9px 16px"
                          >
                            Save Name
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="request-header">
                      <label class="h4 m-0"
                        ><i class="feather card-view"></i> &nbsp;<span
                          class="bold"
                          >Preview</span
                        ></label
                      >
                      @if (active_template.tracked_items.length > 0) {
                        <button
                          (click)="openEditModal()"
                          class="btn btn-primary"
                          style="margin-left: 15px"
                        >
                          Edit
                        </button>
                      }
                    </div>
                    @for (
                      tracked_item of active_template.tracked_items;
                      track tracked_item.uuid
                    ) {
                      <div class="message-bubble tracked-item created">
                        <tracked-item-bubble
                          class="no-hover template-manager"
                          [tracked_item]="tracked_item"
                          [user]="user"
                          [conversation]="{ id: 0 }"
                          [isTemplateManager]="true"
                        >
                        </tracked-item-bubble>
                      </div>
                    }
                    <button
                      (click)="deleteTrackedItemsTemplate()"
                      class="btn btn-danger"
                      style="margin-top: 20px; margin-bottom: 100px"
                    >
                      Delete Template
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="tracked-item-template-footer">
            <div class="row">
              <div class="col-sm-6 text-left">
              </div>
              <div class="col-sm-6 text-right">
              </div>
            </div>
          </div> -->
          </div>
        </div>
      }
    </div>
  }

  <!-- Client tasks templates -->
  @if (jobsTab) {
    <div class="tracked-item-dashboard-wapper" style="display: flex">
      <ch-job-templates class="ch-panels" style="display: flex">
      </ch-job-templates>
    </div>
  }
</div>
